import { Controller } from "@hotwired/stimulus"
import consumer from "../../channels/consumer"

export default class extends Controller {

  connect() {
    this.modalsController._openModal(this.element.getAttribute('id'))
    this.connectToChannel(this.element.getAttribute('id'))
    //only do this if the poll is open!!
  }

  openNotification(){
    this.modalsController.goForward('send-notification')
  }

  openConference(){
    this.modalsController.goForward('conference-call-preview')
  }

  get modalsController() {
    return this.application.getControllerForElementAndIdentifier(this.element, "modals")
  }

  connectToChannel(room) {
    if (!this.subscription) {
      this.subscription = consumer.subscriptions.create(
        { channel: "PollResponseTableChannel", room: room },
        {
          connected() {},
          disconnected() {},
          received(data) {
            const $data = $(data)
            const $element = $data.data('room')
            const $content = $data.first()
            $(`#${room}`).find(".modal-content").replaceWith($content)
          }
        }
      );
    }
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

}
